import { API_PATHS } from '@/constants/api-paths'
import { api } from '@/lib/api'
import type { ApiResponse } from '@/types'

export interface PortalNotification {
  id: number
  service_instance_id: string
  event_type: string
  title: string
  message: string
  entity_type?: string | null
  entity_id?: string | null
  payload?: Record<string, unknown>
  created_on?: string | null
}

type PortalNotificationsListOptions = {
  serviceInstanceId: string
  sinceId?: number | null
  limit?: number
}

export const portalNotificationsApi = {
  async list(options: PortalNotificationsListOptions): Promise<PortalNotification[]> {
    const serviceInstanceId = String(options.serviceInstanceId || '').trim()
    if (!serviceInstanceId) {
      return []
    }

    const params: Record<string, string | number> = {
      service_instance_id: serviceInstanceId,
      limit: Math.max(1, Math.min(options.limit ?? 20, 50)),
    }

    if (options.sinceId != null && Number.isFinite(options.sinceId)) {
      params.since_id = Number(options.sinceId)
    }

    const response = await api.get<ApiResponse<PortalNotification[]>>(API_PATHS.portalNotifications.list, { params })
    return Array.isArray(response.data?.data) ? response.data.data : []
  },
}
